// Общий набор эмодзи: пикер реакций в меню сообщения и пикер в редакторе.
// prettier-ignore
export const EMOJIS = [
    "👍", "👎", "❤️", "🔥", "🎉", "👏",
    "🙏", "💯", "😀", "😃", "😄", "😁",
    "😆", "😅", "😂", "🤣", "😊", "🙂",
    "😉", "😍", "🥰", "😘", "😋", "😎",
    "🤔", "🤨", "😐", "😴", "😢", "😭",
    "😡", "🤯", "🥳", "😱", "😳", "🥺",
    "😬", "🙄", "🤤", "🤗", "👀", "🙌",
    "👌", "✌️", "🤞", "🤝", "💪", "🫶",
    "⭐", "✨", "🌟", "💥", "💦", "🎯",
];
